export const formatCurrency = (v, currency = "COP") => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(num)
}

export const formatNumber = (v, decimals = 0) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num)
}

export const formatPercent = (v, decimals = 2) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return `${num.toFixed(decimals)}%`
}

export const formatGrowth = v => {
  const num = Number(v)
  if (!isFinite(num)) return { text: "—", color: "#64748b", icon: "minus" }
  const text = `${num > 0 ? "+" : ""}${num.toFixed(2)}%`
  if (num > 0) return { text, color: "#10b981", icon: "trending-up" }
  if (num < 0) return { text, color: "#ef4444", icon: "trending-down" }
  return { text, color: "#64748b", icon: "minus" }
}

export const PALETA = [
  "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6",
  "#ec4899", "#06b6d4", "#84cc16", "#f97316", "#6366f1",
  "#14b8a6", "#eab308", "#a855f7", "#22c55e", "#0ea5e9",
]

export const colorPara = i => PALETA[i % PALETA.length]

// Severidad → color
export const severidadColor = sev => {
  switch (sev) {
    case "alta": return { color: "#991b1b", bg: "#fee2e2", border: "#fecaca", icon: "alert-octagon" }
    case "media": return { color: "#92400e", bg: "#fef3c7", border: "#fde68a", icon: "alert" }
    case "baja": return { color: "#1e40af", bg: "#dbeafe", border: "#bfdbfe", icon: "information" }
    default: return { color: "#475569", bg: "#f1f5f9", border: "#e2e8f0", icon: "alert-circle-outline" }
  }
}

// Regla del POS → label + color
export const reglaConfig = regla => {
  switch (regla) {
    case "ajuste_unico":
      return { label: "Único", color: "#065f46", bg: "#d1fae5", desc: "Método único, valor ajustado al total" }
    case "ajuste_efectivo":
      return { label: "Efectivo ajustado", color: "#1e40af", bg: "#dbeafe", desc: "Mixto: efectivo recalculado para cuadrar" }
    case "sin_ajuste":
      return { label: "Sin ajuste", color: "#991b1b", bg: "#fee2e2", desc: "Requiere revisión manual" }
    default:
      return { label: regla || "—", color: "#475569", bg: "#f1f5f9", desc: "" }
  }
}

// Estado de conciliación datáfono vs POS → semáforo
export const estadoConciliacionConfig = estado => {
  switch (estado) {
    case "CUADRA":
      return { label: "Cuadra", color: "#065f46", bg: "#d1fae5", icon: "check-circle", desc: "El datáfono coincide con la porción tarjeta reportada" }
    case "DIFERENCIA":
      return { label: "Diferencia", color: "#991b1b", bg: "#fee2e2", icon: "alert-circle", desc: "El datáfono no coincide con lo reportado — revisar" }
    case "SIN_REPORTE":
      return { label: "Sin reporte", color: "#92400e", bg: "#fef3c7", icon: "help-circle", desc: "Hay datáfono pero la factura no tiene métodos de pago registrados" }
    default:
      return { label: estado || "—", color: "#475569", bg: "#f1f5f9", icon: "circle-outline", desc: "" }
  }
}

// Fecha corta "dd/mm/yyyy" a partir de "YYYY-MM-DD" o ISO, sin desfase de zona.
export const formatFechaCorta = v => {
  if (!v) return "—"
  const s = String(v)
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) return `${m[3]}/${m[2]}/${m[1]}`
  return s
}

// Calcular fecha_inicio y fecha_fin del mes para el endpoint de facturas
export const rangoDelMes = (year, month) => {
  const yyyy = String(year)
  const mm = String(month).padStart(2, "0")
  // último día del mes
  const ultimo = new Date(year, month, 0).getDate()
  return {
    fecha_inicio: `${yyyy}-${mm}-01`,
    fecha_fin: `${yyyy}-${mm}-${String(ultimo).padStart(2, "0")}`,
  }
}
